import { render, staticRenderFns } from "./derivatives-training.vue?vue&type=template&id=e61a76e4"
import script from "./derivatives-training.vue?vue&type=script&lang=js"
export * from "./derivatives-training.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoBox: require('/vercel/path0/components/InfoBox.vue').default})
